import { css } from 'lit';

export const headerStyle = css`
    .header-container {
        width: 100%;
        box-sizing: border-box;
        padding: 16px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 1400px;
        margin: 0 auto;
    }
    
    .mobile-header {
        height: 56px;
        padding: 8px;
        max-width: 100vw;
    }
    
    .left-content {
    }
    
    .right-content {
        display: flex;
        align-items: center;
        gap: 8px;
    }

`
